import React,{useState} from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './Components/IHCA2026/Header';
import Login from './Components/IHCA2026/Login';
import Lobby from './Components/IHCA2026/Lobby';
import SpeakerList from './Components/IHCA2026/speakers/SpeakerList';
import SpeakerDetails from './Components/IHCA2026/speakers/SpeakerDetails';
import SponsorList from './Components/IHCA2026/sponsors/Sponsors';
import SponsorDetails from './Components/IHCA2026/sponsors/SponsorDetails';
import AttendeesList from './Components/IHCA2026/attendee/Attendees';
import AttendeeDetails from './Components/IHCA2026/attendee/AttendeeDetails';
import ExhibitHall from './Components/IHCA2026/attendee/ExhibitHall';
import ExhibitorDetails from './Components/IHCA2026/attendee/ExhibitorDetails';
import ConferenceSchedule from './Components/IHCA2026/conference/getSession';
import Maps from './Components/IHCA2026/Maps/Maps';
import MapDetail from './Components/IHCA2026/Maps/MapDetail';
import UserProfile from './Components/IHCA2026/UserProfile';
import LoginSplash from './Components/IHCA2026/LoginSplash';
import ExhibitorProfile from './Components/IHCA2026/Exhibitor/profile';
import SpeakerProfile from './Components/IHCA2026/speakers/SpeakerProfile';
import ChatPage from "./TmChat/IHCA2026/chat/ChatPage";
import ChatNotification from "./TmChat/IHCA2026/chat/ChatNotification";

import PrivateRoute from './PrivateRoute';


const IHCA2026 = () => {
    const [exhibitorToken,setExhibitorToken] = useState(localStorage.getItem('exhibitorToken') || null);

    return (
        <Router>
            <Header exhibitorToken={exhibitorToken} />
            {exhibitorToken?<ChatNotification />:''}
            <Switch>
                {/* <Route path="/" exact component={Login} /> */}
                <Route path="/ihca2026/login/:id" exact render={(props) => <Login setExhibitorToken={setExhibitorToken} {...props}/>} />
                <PrivateRoute path="/ihca2026/loginSplash" exact component={LoginSplash} />
                <PrivateRoute path="/ihca2026/conference" exact component={ConferenceSchedule} />
                <PrivateRoute path="/ihca2026/lobby" exact component={Lobby} />
                <PrivateRoute path="/ihca2026/speakers" exact component={SpeakerList} />
                <PrivateRoute path="/ihca2026/speakers/:id" exact component={SpeakerDetails} />
                <PrivateRoute path="/ihca2026/sponsors" exact component={SponsorList} />
                <PrivateRoute path="/ihca2026/sponsor/:id" exact component={SponsorDetails} />
                <PrivateRoute path="/ihca2026/attendees" exact component={AttendeesList} />
                <PrivateRoute path="/ihca2026/attendee/exhibitHall" exact component={ExhibitHall} />
                <PrivateRoute path="/ihca2026/attendee/exhibitor/:exhibitorId/:title" exact component={ExhibitorDetails} />
                {/* <PrivateRoute path="/mdapa2024/attendee/:emailId/:userId" exact component={AttendeeDetails} /> */}
                <PrivateRoute path="/ihca2026/attendee/:emailId/" exact component={AttendeeDetails} />
                <PrivateRoute path="/ihca2026/maps" exact component={Maps} />
                <PrivateRoute path="/ihca2026/maps/details" exact component={MapDetail} />
                <PrivateRoute path="/ihca2026/user/profile" exact component={UserProfile} />
                <PrivateRoute path="/ihca2026/exhibitor/profile" exact component={ExhibitorProfile} />
                <PrivateRoute path="/ihca2026/speaker/profile" exact component={SpeakerProfile} />
                <PrivateRoute path="/ihca2026/chat" exact component={ChatPage} />
                

            </Switch>
        </Router>
    )
}
export default IHCA2026;